<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal task">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close()"></div>
        </div>
        <div class="tab">
          <div class="delete-condition-modal">
            <div class="delete-condition-modal-title">
              How should we handle the following task?
            </div>
            <div class="inner-wrap">
              <div class="condition-options">
                <ul v-if="showDeletePopup === t.id" class="popup-list">
                  <li @click="removeCondition(t, 'delete')">
                    <div class="content-wrap">
                      <div class="condition-img">
                        <img
                          src="../../assets/img/remove-both-block.png"
                          alt=""
                        />
                      </div>
                      <div class="figure-caption">
                        1. {{ deleteOptions['delete'] }}
                      </div>
                    </div>
                  </li>
                  <li
                    v-if="
                      findExistingPath(t) === true ||
                      findExistingPath(t) === 'both'
                    "
                  >
                    <div
                      class="content-wrap"
                      @click="removeCondition(t, 'true')"
                    >
                      <div class="condition-img">
                        <img
                          src="../../assets/img/remove-false-block.png"
                          alt=""
                        />
                      </div>
                      <div class="figure-caption">
                        2. {{ deleteOptions['true'] }}
                      </div>
                    </div>
                  </li>
                  <li
                    v-if="
                      findExistingPath(t) === false ||
                      findExistingPath(t) === 'both'
                    "
                  >
                    <div
                      class="content-wrap"
                      @click="removeCondition(t, 'false')"
                    >
                      <div class="condition-img">
                        <img
                          src="../../assets/img/remove-true-block.png"
                          alt=""
                        />
                      </div>
                      <div class="figure-caption">
                        3. {{ deleteOptions['false'] }}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deleteConditionModal',
  data() {
    return {
      deleteOptions: {
        delete: 'Delete all following tasks',
        true: 'Keep the true path',
        false: 'Keep the false path',
      },
    };
  },
  props: {
    t: Object,
    showDeletePopup: Number,
    process: Object,
    idx: Number,
  },
  methods: {
    close() {
      this.$emit('close');
    },
    findExistingPath(task) {
      const conditionPath = this.process.tasks.filter(
        (item) => item.previousTaskId === task.id
      );
      if (conditionPath.length === 2) {
        return 'both';
      } else {
        if (conditionPath[0].pathType === true) {
          return true;
        } else if (conditionPath[0].pathType === false) {
          return false;
        }
      }
    },
    removeCondition(task, index) {
      let indx = this.process.tasks.indexOf(task);

      const parentTask = this.process.tasks.filter(
        (item) => item.id === task.previousTaskId
      );
      const childTask = this.process.tasks.filter(
        (item) => item.previousTaskId === task.id
      );

      if (this.deleteOptions['delete'] === this.deleteOptions[index]) {
        // set dropzone visible
        if (task.pathType === true) {
          parentTask[0].path.truePath === true;
        } else if (task.pathType === false) {
          parentTask[0].path.falsePath === true;
        }
        this.process.tasks.splice(indx, this.process.tasks.length - indx);
      } else if (this.deleteOptions['true'] === this.deleteOptions[index]) {
        // set previousId to the next task
        childTask.map((item) => {
          if (item.pathType === true) {
            item.previousTaskId = task.previousTaskId;
            item.pathType = task.pathType;
          }
        });
        const obj = childTask.find((item) => item.pathType === false);
        if (obj) {
          const falseIdx = this.process.tasks.findIndex(
            (item) => item.id === obj.id
          );
          this.process.tasks.splice(
            falseIdx,
            this.process.tasks.length - falseIdx
          );
        }
        this.process.tasks.splice(indx, 1);
      } else if (this.deleteOptions['false'] === this.deleteOptions[index]) {
        // set previousId to the next task
        childTask.map((item) => {
          if (item.pathType === false) {
            item.previousTaskId = task.previousTaskId;
            item.pathType = task.pathType;
          }
        });
        const obj = childTask.find((item) => item.pathType === true);

        if (obj) {
          const trueIdx = this.process.tasks.findIndex(
            (item) => item.id === childTask[0].id
          );

          if (childTask.length > 1) {
            const falseIdx = this.process.tasks.findIndex(
              (item) => item.id === childTask[1].id
            );
            this.process.tasks.splice(trueIdx, falseIdx - trueIdx);
          }
        }
        this.process.tasks.splice(indx, 1);
      }
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
}

.tab {
  text-align: left;
  padding: 20px 30px;
  height: 100%;
  align-items: center;
  box-sizing: border-box;
}

.modal.task {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 50% !important;
  height: auto !important;
  max-height: 500px;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: absolute;
  left: 10%;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.pull-right {
  position: absolute;
  right: 0;
  top: 10px;
  z-index: 9;
  cursor: pointer;
}

.modal .btn-close {
  margin-right: 14px;
  width: 13px;
  height: 13px;
}

img {
  max-width: 100%;
}

.delete-condition-modal .inner-wrap h4 {
  font-size: 22px;
  text-align: center;
}

.delete-condition-modal .condition-options ul {
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

.delete-condition-modal .condition-options .figure-caption {
  font-size: 20px;
  color: #6c757d;
  cursor: pointer;
}

.delete-condition-modal .condition-options ul li {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  width: calc((100% / 3) - 10px);
}

.popup-list {
  position: relative;
  margin: 0;
  padding: 0;
  min-width: 150px;
  text-align: left;
  list-style: none;
}
.popup-list li {
  padding: 10px 15px;
  font-size: 14px;
  color: #333;
}
.delete-condition-modal-title {
  font-size: 22px;
  text-align: center;
  font-weight: 600;
  color: #333;
}
.condition-img img {
  max-height: 350px;
}
</style>
